export enum FormattingContext {
    HOURS_TICKET_VALIDITY = 'HOURS_TICKET_VALIDITY',
    MY_TICKET_VALIDITY = 'MY_TICKET_VALIDITY',
    MY_TICKET_SUB_TICKET_VALIDITY = 'MY_TICKET_SUB_TICKET_VALIDITY',
    PERIOD_TICKET_VALIDITY = 'PERIOD_TICKET_VALIDITY',
    TICKET_SUMMARY_VALIDITY = 'TICKET_SUMMARY_VALIDITY',
    DISRUPTION_MESSAGE_DATE_RANGE = 'DISRUPTION_MESSAGE_DATE_RANGE'
}

export enum OffsetContext {
    PERIOD_TICKET_VALIDITY = 'PERIOD_TICKET_VALIDITY',
    PERIOD_TICKET_DATE_FORMAT = 'PERIOD_TICKET_DATE_FORMAT',
    CARD_TICKETS_LIST = 'CARD_TICKETS_LIST',
    MY_TICKET_VALIDITY = 'MY_TICKET_VALIDITY',
    TICKET_SUMMARY_VALIDITY = 'TICKET_SUMMARY_VALIDITY'
}
